import { Text } from '@chakra-ui/react';
import Widget from './Widget';
import { useRoadNetworkUseKPI } from '../../context/reports-api-hooks';
import { CircleIndicator } from '../indicators';
import { roundKpiValue } from '../../shared/helpers';

export default function RoadNetworkUseWidget() {
  const { data: roadNetworkUseData, isLoading, isError } = useRoadNetworkUseKPI();

  const title = 'Road Network Use';
  const description = 'Change in vehicle kilometres\ntravelled over 10 years';

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/road-network-use"
      title={title}
      description={description}
      lockYear={roadNetworkUseData?.lockYear}
      quarter={null}
      isLoading={isLoading && !roadNetworkUseData}
      moreInfoContent={
        <Text fontSize="sm">The average change in road usage per year for the last ten years.</Text>
      }
    >
      <CircleIndicator
        size={100}
        colour={roadNetworkUseData?.percentage !== undefined ? 'gray.700' : null}
        value={roadNetworkUseData?.percentage !== undefined ? `${roundKpiValue(roadNetworkUseData?.percentage, 5, 1, 'max')}%` : undefined}
        isLoading={isLoading || !roadNetworkUseData}
      />
    </Widget>
  );
}
